import React from 'react';
import {
  Box,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { YellowBoxBottom } from './Home';

const AboutUs = () => {
  const model = 'Llama';
  return (
    <Box>
      <Typography variant="homePageBody" paragraph>
        In a world flooded with unreliable predictions and manipulative tactics,
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> was born
        with a simple but profound idea: to rebuild trust in astrology through
        the power of intelligence, ethics, and innovation. We are not just
        another app that throws random forecasts.{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> is a
        result of relentless work an independent intelligence system trained on
        real-world experiences, ancient astrological sciences, and a deep
        understanding of human lives.
        <br />
        At <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>, our
        vision is to create an ecosystem where astrology becomes a tool for
        clarity, empowerment, and personal growth not fear or confusion. We are
        committed to transforming astrology from a guessing game into a
        structured science, making it accessible and trustworthy for every
        individual. Our mission is simple: combine the timeless wisdom of Brihat
        Parashara Hora Shastra, Phaladeepika, Bhrigu Samhita, and Laghu
        Parashari with the precision and speed of advanced AI. Every insight,
        every recommendation, is built not to create dependency, but to guide
        users toward better decisions with confidence.
      </Typography>

      <Typography variant="h3">
        What Makes <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>{' '}
        Different:
      </Typography>

      <List
        component="ol"
        sx={{ listStyleType: 'decimal', pl: 2, pt: 0, pb: '36px' }}
      >
        <ListItem component="li" sx={{ display: 'list-item', pl: 1 }}>
          <ListItemText
            primary={
              <>
                <Box component="span" fontWeight="semi-bold">
                  Accuracy Built on Knowledge:
                </Box>{' '}
                No shortcuts. Every prediction is rooted in refined astrological
                science and real-world data.
              </>
            }
          />
        </ListItem>
        <ListItem component="li" sx={{ display: 'list-item', pl: 1 }}>
          <ListItemText
            primary={
              <>
                <Box component="span" fontWeight="semi-bold">
                  Emotion-Free Guidance:
                </Box>{' '}
                We empower users with clarity and awareness never through fear,
                confusion, or emotional manipulation.
              </>
            }
          />
        </ListItem>
        <ListItem component="li" sx={{ display: 'list-item', pl: 1 }}>
          <ListItemText
            primary={
              <>
                <Box component="span" fontWeight="semi-bold">
                  Self-Optimizing System:
                </Box>{' '}
                Our chatbox and search adapt automatically to user behavior,
                showing the most relevant questions and insights.
              </>
            }
          />
        </ListItem>
        <ListItem component="li" sx={{ display: 'list-item', pl: 1 }}>
          <ListItemText
            primary={
              <>
                <Box component="span" fontWeight="semi-bold">
                  Holistic Solutions:
                </Box>{' '}
                Blending traditional remedies with practical, ethically guided
                actions to support real transformation.
              </>
            }
          />
        </ListItem>
        <ListItem component="li" sx={{ display: 'list-item', pl: 1 }}>
          <ListItemText
            primary={
              <>
                <Box component="span" fontWeight="semi-bold">
                  Personalized & Evolving:
                </Box>{' '}
                <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>{' '}
                becomes smarter with user interactions, making collective
                intelligence available to everyone.
              </>
            }
          />
        </ListItem>
      </List>

      <Typography variant="homePageBody" paragraph>
        Unlike typical astrology apps and self-proclaimed astrologers who often
        operate with less than 30% accuracy,{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> stands
        apart with its commitment to real knowledge and practical solutions. Our
        system goes beyond surface-level predictions; we focus on delivering
        meaningful advice that is rooted in ethical practices and spiritual
        authenticity.
      </Typography>

      <Typography variant="homePageBody" paragraph>
        Technology at{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> is not
        just a tool it’s a bridge. Whether you are searching for insights about
        marriage, career, health, or finance, our dynamic chat system organizes
        your conversations intuitively. With every interaction,{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> gets
        better: learning, adapting, and refining its guidance.
      </Typography>

      <Typography variant="homePageBody" paragraph>
        Our commitment is rooted in values: transparency, respect for ancient
        knowledge, user empowerment, and ethical responsibility. Astrology is
        not about predicting doom or selling hope it’s about helping you
        navigate life with deeper understanding and mindful choices.
        <br />
        This is only the beginning.{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>’s journey
        will continue to evolve with smarter remedies, deeper karmic insights,
        and personalized astrological experiences. Astrology is not a
        replacement for free will, but a tool for deeper self-mastery.
      </Typography>

      <Divider />

      {/* Vision Section */}
      <Typography variant="h2" gutterBottom>
        Our Vision: Redefining the Future of Astrology for Generations to Come
      </Typography>

      <Typography variant="homePageBody">
        At <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>, our
        vision extends far beyond simply creating an intelligent astrology
        application. We are on a mission to reshape the very perception of
        astrology in the modern world and elevate it to a respected science of
        self-realization, decision-making, and cosmic alignment.
      </Typography>

      <Typography variant="homePageBody">
        We believe that astrology, when rooted in authentic tradition and
        empowered with cutting-edge technology, has the potential to unlock a
        new dimension of human consciousness.
      </Typography>

      <Typography variant="homePageBody">
        It can guide individuals not through fear, but through clarity; not
        through manipulation, but through wisdom; not through superstition, but
        through verified cosmic principles.
      </Typography>

      <Typography variant="h3" gutterBottom mt={4}>
        A Global Renaissance of Astrology
      </Typography>

      <Typography variant="body2" paragraph>
        We envision a world where astrology becomes a trusted life companion
      </Typography>

      <List disablePadding>
        <ListItem disableGutters disablePadding>
          <Typography variant="body2">
            • where people turn to astrological insights with the same
            confidence they place in modern medicine or education,{' '}
          </Typography>
        </ListItem>
        <ListItem disableGutters>
          <Typography variant="body2">
            • where predictive intelligence is not vague or generalized but
            personalized, verified, and deeply relevant to each individual's
            journey,{' '}
          </Typography>
        </ListItem>
        <ListItem disableGutters>
          <Typography variant="body2">
            • where ancient scripts like the Brihat Parashara Hora Shastra,
            Phaladeepika, Bhrigu Samhita, and Laghu Parashari are honored,
            studied, and revived through ethical, scientific application.{' '}
          </Typography>
        </ListItem>
      </List>
      <Typography variant="homePageBody" paragraph>
        Our dream is to revive the lost credibility of astrological sciences
        globally integrating its profound wisdom into everyday decision-making
        for career, relationships, health, finance, and spiritual evolution.
      </Typography>

      <Typography variant="h3" mt={4} gutterBottom>
        Our Roadmap for the Next Coming Years
      </Typography>

      <Typography variant="homePageBody" paragraph>
        In the next decade, we aspire to build a new global standard for
        astrology one rooted in authenticity, science, accessibility, and
        ethical practices.
      </Typography>

      <Typography variant="homePageBody" paragraph>
        <Box component="span" fontWeight="semi-bold">
          Create the World’s Largest Ethical Astrological Intelligence Database
          <br />
        </Box>{' '}
        Verified by renowned traditional scholars, experienced astrologers, and
        data scientists alike, this database will form the bedrock of
        intelligent, accurate, and ethical astrological predictions for
        generations to come.
      </Typography>

      <Typography variant="homePageBody" paragraph>
        <Box component="span" fontWeight="semi-bold">
          Launch Hyper-Personalized Astrological Ecosystems
        </Box>{' '}
        <br />A seamless universe where users can navigate critical life
        decisions career, relationships, health, finances, and spiritual
        evolution through insights aligned precisely with their unique karmic
        blueprint. No more generalized advice; only guidance tailored to their
        true birth charts.
      </Typography>

      <Typography variant="homePageBody" paragraph>
        <Box component="span" fontWeight="semi-bold">
          Establish Astrology as a Recognized Academic Discipline
        </Box>{' '}
        <br />
        Partnering with educational institutions, cultural bodies, and research
        foundations, we aim to reintroduce astrology as a respected field of
        academic inquiry and scientific study, beyond superstition and
        misunderstanding.
      </Typography>

      <Typography variant="homePageBody" paragraph>
        <Box component="span" fontWeight="semi-bold">
          Expand <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>{' '}
          into Multiple Languages and Cultures
        </Box>{' '}
        <br />
        Making sure that Vedic astrology’s true wisdom becomes accessible to
        every human being, regardless of nationality, religion, language, or
        cultural background bringing the ancient science closer to the daily
        life of millions.
      </Typography>

      <Typography variant="homePageBody" paragraph>
        <Box component="span" fontWeight="semi-bold">
          Revolutionize the Gemstone Industry
        </Box>{' '}
        <br />
        In an era where gemstone markets are largely unregulated and often
        exploitative, we commit to providing
        <Box component="span" fontWeight="medium" fontStyle="italic">
          {' '}
          100% authentic, astrologically relevant gemstones{' '}
        </Box>
        to our users. Through a combination of AI-driven verification, lab
        certifications, and ethical sourcing, we will help restore trust in this
        vital aspect of astrological remedies.
      </Typography>

      <Typography variant="homePageBody" paragraph>
        <Box component="span" fontWeight="semi-bold">
          Constantly Evolve Our AI for Deeper Vedic Understanding
        </Box>{' '}
        <br />
        Our AI will evolve continuously, studying millions of verified charts
        and real-world case studies, becoming more aligned with traditional
        Jyotish principles while ensuring absolute precision and ethical
        guidance.
      </Typography>

      <Typography variant="homePageBody" paragraph>
        <Box component="span" fontWeight="semi-bold">
          Empower Our Knowledge Core by Hiring Eminent Young Astrologers
        </Box>{' '}
        <br />
        We will build a{' '}
        <Box component="span" fontWeight="medium" fontStyle="italic">
          global network of brilliant, young, and ethically grounded astrologers
        </Box>
        , collaborating with them to enhance our database, refine our models,
        and ensure the soul of astrology is preserved even as we scale
        technologically.
      </Typography>

      <Typography variant="homePageBody" paragraph>
        <Box component="span" fontWeight="semi-bold">
          Redefine User Experience with Self-Adaptive Interfaces
        </Box>{' '}
        <br />
        Our platforms will intelligently learn from each user's journey,
        providing seamless access to birth charts, predictive insights, gemstone
        recommendations, and life guidance all rooted in their personal
        celestial map.
      </Typography>

      <Divider />

      <Typography variant="h2">Data Security & Privacy</Typography>
      <Typography variant="homePageBody" paragraph>
        Because our models run entirely on private servers, no user data is ever
        used by other technology giants for their own training. All birth
        details, chart data, and query history stay encrypted in our local
        database and in-memory models. As one expert guide explains, “using
        cloud-based LLMs… often means companies lose control over their data”,
        whereas a self-hosted model “offers greater security, privacy, and
        compliance”
      </Typography>

      <YellowBoxBottom sx={{ textAlign: 'left' }}>
        <Typography variant="h3" textAlign="center" gutterBottom>
          Our Ultimate Dream
        </Typography>

        <Typography variant="homePageBody" paragraph>
          <Box component="span" fontWeight="bold">
            Astrology is no longer dismissed as mere "fortune-telling," but
            embraced as a profound science of conscious living,
          </Box>{' '}
          harmonized with the eternal laws of the universe.
        </Typography>

        <Typography variant="homePageBody" paragraph>
          <Box component="span" fontWeight="bold">
            Every individual from the smallest village to the largest metropolis
            can access authentic, verified astrological wisdom,
          </Box>{' '}
          free from fear-driven tactics, confusion, and emotional manipulation.
        </Typography>

        <Typography variant="homePageBody" paragraph>
          <Box component="span" fontWeight="bold">
            Technology acts not as a disruptor, but as a guardian of sacred
            tradition
          </Box>{' '}
          preserving the ancient Vedic knowledge while intelligently adapting it
          to serve the needs of the modern world.
        </Typography>

        <Divider />

        <Typography variant="homePageBody" paragraph>
          <Box component="span" fontWeight="bold">
            Humanity reconnects with a higher cosmic order
          </Box>{' '}
          empowering each soul to realize their true potential, not merely as
          isolated individuals, but as essential threads woven into the vast,
          intelligent design of existence.
        </Typography>
      </YellowBoxBottom>
    </Box>
  );
};

export default AboutUs;
